<template>
  <div class="user_info_form register_agree">
    <h4 class="access_hidden">이용약관 동의</h4>
    <div class="agree">
      <check-box
        @custom-checked="handleCheck(1)"
        :checked="agreeCheck1"
        id="agreeBusiness"
        text="개인정보 수집 및 이용 동의"
      />
      <v-button
        class="btn_open"
        @handleClick="agreeLayerChange(4)"
        text="개인정보 수집 및 이용 동의 내용 보기"
        :textHide="true"
      />
    </div>
    <!--    <div class="agree">-->
    <!--      <v-icon clsName="icon_agree" />-->
    <!--      개인정보 위탁 안내-->
    <!--      <v-button-->
    <!--        class="btn_open"-->
    <!--        @handleClick="agreeLayerChange(5)"-->
    <!--        text="개인정보 위탁 안내 내용 보기"-->
    <!--        :textHide="true"-->
    <!--      />-->
    <!--    </div>-->

    <!-- 법인->법인인 경우는 안내 불필요 -->
    <template v-if="userInfo.businessType === 2 || userInfo.businessType === 3">
      <div></div>
    </template>
    <!--    개인에서 개인사업자/법인사업자에서 변경시에는 주민번호 입력 필요하여 개인정보 수집 및 이용안내 추가 -->
    <template v-else-if="!userInfo.isCheckedIdNo">
      <div class="hr"></div>
      <div class="agree">
        <v-icon clsName="icon_agree" />
        개인정보 수집 및 이용 안내
        <v-button
          class="btn_open"
          @handleClick="agreeLayerChange(5)"
          text="개인정보 수집 및 이용 안내"
          :textHide="true"
        />
      </div>
    </template>
    <agree-layer @custom-change="agreeLayerChange(0)" :state="agreeLayer" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CheckBox from '@/components/atoms/CheckBox';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';
import AgreeLayer from '@/components/modules/common/AgreeLayer';

export default {
  components: {
    CheckBox,
    VButton,
    VIcon,
    AgreeLayer,
  },
  data() {
    return {
      agreeCheck1: false,
      agreeLayer: 0,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    agreeLayerChange(val) {
      this.agreeLayer = val;
    },
    handleCheck(val) {
      this.agreeCheck1 = !this.agreeCheck1;
      this.$emit('update', { isState: this.agreeCheck1 });
    },
  },
  mounted() {},
};
</script>
<style lang="scss"></style>
